import { combineReducers } from "redux";
import { reducer as toastrReducer } from "react-redux-toastr";
import { app } from "./appReducer";
import { register, validatePhone, validateEmail } from "./registerReducer";
import { validate } from "./validateReducer";
import { validateUrlName, listCountries, listTimezones, listLanguages, listIndustries, listProfiles, listRoles } from "./step2Reducer";

const rootReducer = combineReducers({
  app,
  register,
  validatePhone,
  validateEmail,
  validate,
  validateUrlName,
  listCountries,
  listTimezones,
  listIndustries,
  listProfiles,
  listRoles,
  listLanguages,
  toastr: toastrReducer,

});

export default rootReducer;
